<template>
<div class="inline-flex flex-col" :class="{'opacity-50 pointer-events-none': disabled, 'pointer-events-none': displayOnly >= 0 }">
	<slot name="title"/>
	<div class="flex" :class="{ 'mt-4 mb-3': !noMargins }">
		<div v-for="n in count" :key="n" class="flex justify-center items-center px-0.5 first:pl-0" :style="style" @click="rate(n)" @mouseover="hover(n)" @mouseout="unhover">
			<BaseIcon name="star-on" class="cursor-pointer" :size="size" :class="n <= (displayOnly >= 0 ? displayOnly : hoverRating) ? 'text-accent' : 'text-neutral-design-200'"/>
		</div>
	</div>
	<span v-if="showRatingText" class="text-xs md:text-sm">
		{{ ratingText }}
	</span>
</div>
</template>

<script>
import BaseIcon from './BaseIcon.vue';

export default {
	name: 'StarRating',
	components: {
		BaseIcon,
	},
	props: {
		size: { default: 1.25, type: [String, Number] },
		count: { default: 5, type: [Number] },
		disabled: { default: false, type: Boolean },
		showRatingText: { default: false, type: Boolean },
		displayOnly: { default: -1, type: Number },
		noMargins: { default: false, type: Boolean },
		rateFromChat: { default: false, type: Boolean },
	},
	emits: ['rating'],
	data() {
		return {
			rating: 0,
			hoverRating: 0,
			ratingText: `Na skali od 1 do ${this.count} gwiazdek, jak oceniasz współpracę z tym Wykonawcą?`,
		};
	},
	computed: {
		style() {
			return {
				flex: ` 0 0 ${this.size}rem`,
				width: `${this.size}rem`,
				height: `${this.size}rem`,
			};
		},
	},
	methods: {
		rate(star) {
			this.rating = star;
			this.changeRatingText(0);
			this.$emit('rating', star);
		},
		hover(star) {
			this.hoverRating = star;
			this.changeRatingText(0);
		},
		unhover() {
			this.hoverRating = this.rating;
			this.changeRatingText(0);
		},
		changeRatingText(star) {
			switch (star) {
			case (-1):
				this.ratingText = 'Tylko klienci Oferteo mogą wystawić neutralną lub negatywną opinię. Przejdź do swoich zleceń i wybierz Wykonawcę, któremu chcesz wystawić 1-3 gwiazdki.';
				break;
			case 0:
				this.ratingText = `Na skali od 1 do ${this.count} gwiazdek, jak oceniasz współpracę z tym Wykonawcą?`;
				break;
			case 1:
				this.ratingText = 'Fatalna';
				break;
			case 2:
				this.ratingText = 'Niezadowalająca';
				break;
			case 3:
				this.ratingText = 'Przeciętna';
				break;
			case 4:
				this.ratingText = 'Dobra';
				break;
			default:
				this.ratingText = 'Doskonała';
				break;
			}
		},
	},
};
</script>
